module.exports = __webpack_public_path__ + "img/menu-5.48624b68.png";